import LinksInfo from './LinksInfo';

export default LinksInfo;
